import React from 'react'
import Head from 'next/head'

import {
  DEFAULT_ARTICLE_KEYWORDS,
  DEFAULT_ARTICLE_DESCRIPTION,
} from 'Constants/index'

interface IProps {
  title?: string
  keywords?: string
  description?: string
}

export default React.memo(({ title, keywords, description }: IProps) => (
  <Head>
    <title key="title">{title}</title>
    <meta
      key="keywords"
      name="keywords"
      content={keywords || DEFAULT_ARTICLE_KEYWORDS}
    />
    <meta
      key="description"
      name="description"
      content={description || DEFAULT_ARTICLE_DESCRIPTION}
    />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Head>
))
